import { render, staticRenderFns } from "./OrdersTable.vue?vue&type=template&id=a27ed04e&scoped=true"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OrdersTable.vue?vue&type=style&index=1&id=a27ed04e&prod&lang=css"
import style2 from "./OrdersTable.vue?vue&type=style&index=2&id=a27ed04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ed04e",
  null
  
)

export default component.exports